import moment from 'moment';
import { Translator } from 'modules/i18n';

export function dateStringToDateObject(date) {
    if (!date) {
        return {
            day: '',
            month: '',
            year: '',
        };
    }
    const dateArray = date.split('-');
    return {
        day: dateArray[2] || '',
        month: dateArray[1] || '',
        year: dateArray[0] || '',
    };
}

export function dateStringOneFieldToDateObject(date) {
    if (!date) {
        return {
            day: '',
            month: '',
            year: '',
        };
    }
    const dateArray = date.split(' / ');
    return {
        day: dateArray[0] || '',
        month: dateArray[1] || '',
        year: dateArray[2] || '',
    };
}

export function dateObjectToDateString({ year, month, day }) {
    return `${year}-${month}-${day}`;
}

export function dateObjectOneFieldToDateString({ year, month, day }) {
    return `${day} / ${month} / ${year}`;
}

export function momentNow() {
    return moment();
}

export function getDayBeforeDate(date) {
    return moment(date)
        .subtract(24, 'hours')
        .toISOString();
}

export function isTodayOrAfter(date) {
    return momentNow()
        .startOf('day')
        .isSameOrBefore(moment(date));
}

export function getLocalizedWeekdayFromDayAsNumber(day, locale) {
    return [
        Translator.trans(locale, 'global.weekday.monday'),
        Translator.trans(locale, 'global.weekday.tuesday'),
        Translator.trans(locale, 'global.weekday.wednesday'),
        Translator.trans(locale, 'global.weekday.thursday'),
        Translator.trans(locale, 'global.weekday.friday'),
        Translator.trans(locale, 'global.weekday.saturday'),
        Translator.trans(locale, 'global.weekday.sunday'),
    ][day - 1];
}

export const removeSeconds = dateString => dateString.substr(0, dateString.length - 3);

export const formatDistributionsDate = (distributions, locale) => {
    if (!Array.isArray(distributions) || distributions.length === 0) return '';

    const andWord = Translator.trans(locale, 'global.and');

    // S'il n'y a qu'une seule date, on affiche le jour de la semaine
    if (distributions.length === 1) {
        const date = new Date(distributions[0].dateTimeEnd);
        const weekday = date.toLocaleString(locale, { weekday: 'long' });
        const day = date.getDate();
        const month = date.toLocaleString(locale, { month: 'long' });

        return `${weekday} ${day} ${month}`;
    }

    // Group days by month
    const monthsMap = new Map();
    for (const dist of distributions) {
        const date = new Date(dist.dateTimeEnd);
        const day = date.getDate();
        const month = date.toLocaleString(locale, { month: 'long' });

        if (!monthsMap.has(month)) monthsMap.set(month, []);
        monthsMap.get(month).push(day);
    }

    // Format each month: sort and merge days
    const monthParts = [];
    for (const [month, days] of monthsMap.entries()) {
        const sortedDays = [...new Set(days)].sort((a, b) => a - b);
        const dayStr =
            sortedDays.length === 1
                ? sortedDays[0]
                : `${sortedDays.slice(0, -1).join(', ')} ${andWord} ${sortedDays.at(-1)}`;
        monthParts.push(`${dayStr} ${month}`);
    }

    // Case 1 month
    if (monthParts.length === 1) return monthParts[0];

    // Case 2 months (e.g. “June 25 and August 2, 10”)
    if (monthParts.length === 2) {
        return `${monthParts[0]} ${andWord} ${monthParts[1]}`;
    }

    // Case 3+ months (e.g. “June 25, August 2 and September 3”)
    const last = monthParts.pop();
    return `${monthParts.join(', ')} ${andWord} ${last}`;
};
